import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function EmergencyContactDisplay({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
      className={`flex p-[24px] flex-col gap-[24px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      id="emergencyContactScrollId"
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("emergencyContact")}
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[20px]">
        <LabelComponent
          title={t("name")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails?.name ?? "-"
          }`}
        />
        <LabelComponent
          title={t("relationship")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails
              ?.relationship ?? "-"
          }`}
        />
        <LabelComponent
          title={t("email")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails?.email ?? "-"
          }`}
        />
        <LabelComponent
          title={t("country")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails?.country ??
            "-"
          }`}
        />
        <LabelComponent
          title={t("phoneNumber")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails
              ?.mobileNumber ?? "-"
          }`}
        />
        <LabelComponent
          title={t("alternativePhoneNumber")}
          subTitle={`${
            userDetails?.extraInformation?.emergencyContactDetails
              ?.homeTelephone ?? "-"
          }`}
        />
      </div>
    </div>
  );
}

EmergencyContactDisplay.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default EmergencyContactDisplay;
